export const Nav = [
    { id: 'About', label: 'About' },
    { id: 'Service', label: 'Service' },
    { id: 'Product', label: 'Product' },
    { id: 'Partners', label: 'Partners' },
    { id: 'News', label: 'News' },
    { id: 'Notice', label: 'Notice' },
    { id: 'ContactUs', label: 'Contact Us' },
];